function bannerSetup(){
	var banner = document.getElementsByClassName('banner')[0];
	banner.classList.add('is-hidden'); // and hide it

	// Show the header if mouse enter
	document.getElementById('banner-logo').addEventListener('mouseenter', function(){
		if (banner.classList.contains('is-hidden')){
			banner.classList.remove('is-hidden');
			banner.classList.add('button-trigger');
		}
	});
}

// Function to show or hide the banner
var bannerScroll = throttle(function (){

	// Get the height of the header
	var past = pastHeader();

	var banner = document.getElementsByClassName('banner')[0];

	// If the header has been trigger by the logo
	if(banner.classList.contains('button-trigger')){

		if(past){ // If we are below the header
			banner.classList.remove('button-trigger'); // Remove the trigger
			banner.classList.remove('is-hidden'); // Show the banner
		}

	} else { // The logo did nothing

		if(past){ // If we are below the header
			banner.classList.remove('is-hidden'); // Show the banner
		} else { // We are in the header
			banner.classList.add('is-hidden'); // Hide the banner
		}
	}
}, 250);
